import React, { useEffect, useState } from 'react'
import Page from '../../../../component/Page'
import { addMaterialsReturns, getBranchList, getBudgetYearsList, getDepartmentsList, getMaterialsBalanceList, getMaterialsBorrowedList } from '../../services/api'
import { useNavigate, useParams } from 'react-router-dom'
import TitlePage from '../../../../component/TitlePage'
import { Autocomplete, Box, Button, FormControl, MenuItem, OutlinedInput, Select, TextField, Typography } from '@mui/material'
import dayjs from 'dayjs'
import DatePicker from '../../../../component/DatePicker'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowLeft, faMinusCircle, faPlusCircle } from '@fortawesome/free-solid-svg-icons'
import ConfirmDialog from '../component/ConfirmDialog'
import { useSelector } from 'react-redux'

export default function MaterialsReturnsAdd() {
  const navigate = useNavigate();
  const { profile } = useSelector(state => state.profile)
  const { id } = useParams()
  const [open, setOpen] = useState(false)
  const [loadingSubmit, setLoadingSubmit] = useState(false)
  const [branchs, setBranchs] = useState([])
  const [budgetYears, setBudgetYears] = useState([])
  const [materials, setMaterials] = useState([])
  const [departments, setDepartments] = useState([])
  const [returnsDate, setReturnsDate] = useState(dayjs(new Date()))
  const [branchNo, setBranchNo] = useState('')
  const [branchNoError, setBranchNoError] = useState(false)
  const [toBranchNo, setToBranchNo] = useState('')
  const [toBranchNoError, setToBranchNoError] = useState(false)
  const [departmentName, setDepartmentName] = useState('')
  const [departmentNameError, setDepartmentNameError] = useState(false)
  const [toDepartmentName, setToDepartmentName] = useState('')
  const [toDepartmentNameError, setToDepartmentNameError] = useState(false)
  const [documentType, setDocumentType] = useState('คืน-จ่าย')

  const [rows, setRows] = useState([
    {
      RefNo: "",
      ItemNo: null,
      BudgetYear: 0,
      BudgetType: "",
      Lot: "",
      Qty: 0,
      UnitNo: "",
      CostPrice: 0,
      Width: "",
      Length: "",
      Thick: "",
      Status: "",
      Remark: ""
    }
  ])
  function addRow() {
    const newRow = {
      RefNo: "",
      ItemNo: null,
      BudgetYear: 0,
      BudgetType: "",
      Lot: "",
      Qty: 0,
      UnitNo: "",
      CostPrice: 0,
      Width: "",
      Length: "",
      Thick: "",
      Status: "",
      Remark: ""
    }

    setRows([...rows, newRow]);
  }
  const deletehand = (i) => {
    const data = rows?.filter((e, index) => i !== index);
    setRows(data);
  };
  useEffect(() => {
    const getBranch = async () => {
      const data = await getBranchList()
      setBranchs(data)
    }
    const getDepartments = async () => {
      const data = await getDepartmentsList()
      setDepartments(data)
    }
    const getBudgetYears = async () => {
      const data = await getBudgetYearsList()
      setBudgetYears(data)
    }
    getBranch()
    getDepartments()
    getBudgetYears()
    setBranchNo(profile?.BranchNo?.BranchNo)
  }, [])
  useEffect(() => {
    const getMaterials = async () => {
      const data = await getMaterialsBalanceList(branchNo, departmentName, documentType)
      setMaterials(data)
    }
    if (branchNo, departmentName) {
      getMaterials()
    }
    setRows([
      {
        RefNo: "",
        ItemNo: null,
        BudgetYear: 0,
        BudgetType: "",
        Lot: "",
        Qty: 0,
        UnitNo: "",
        CostPrice: 0,
        Width: "",
        Length: "",
        Thick: "",
        Status: "",
        Remark: ""
      }
    ])
  }, [branchNo, departmentName, documentType])

  const handleSubmit = async () => {
    const body = {
      DocumentType: documentType,
      DocumentDate: dayjs(returnsDate).format('YYYY-MM-DD'),
      BranchNo: branchNo,
      ToBranchNo: toBranchNo,
      DepartmentName: departmentName,
      ToDepartmentName: toDepartmentName,
      Status: "Y",
      Details: rows?.map((item) => ({
        RefNo: item?.RefNo,
        ItemNo: item?.ItemNo?.ItemNo,
        BudgetYear: item?.BudgetYear,
        BudgetType: item?.BudgetType,
        Lot: item?.Lot,
        Qty: item?.Qty.toString().replaceAll(',', ''),
        UnitNo: item?.UnitNo?.UnitNo,
        CostPrice: item?.CostPrice,
        Width: item?.RequireSize ? item?.Width : '',
        Length: item?.RequireSize ? item?.Length : '',
        Thick: item?.RequireSize ? item?.Thick : '',
        Status: item?.Status,
        Remark: item?.Remark

      }))
    }
    const post = async () => {
      const res = await addMaterialsReturns(body)
      if (res) {
        setLoadingSubmit(false)
        setOpen(false)
        navigate('/materials/materials-returns/' + res.DocumentNo, { state: { new: true } })
      }
    }
    post()
  }
  return (
    <Page>
      <TitlePage title='เพิ่มการคืนวัสดุ' />
      <Box class="row">
        <div class="col-lg-4 col-md-6" style={{ marginBottom: '10px' }}>
          <label class="labelInput">ประเภทเอกสาร</label>
          <Box className={`backgroundField`}>
            <FormControl variant="standard" fullWidth disabled={id ? true : false}>
              <Select value={documentType} onChange={e => {
                setDocumentType(e.target.value)
              }} disableUnderline
                MenuProps={{ PaperProps: { sx: { maxHeight: 400 } } }}
              >
                <MenuItem value={'คืน-จ่าย'}>{'คืน-จ่าย'}</MenuItem>
                <MenuItem value={'คืน-ยืม'}>{'คืน-ยืม'}</MenuItem>
                <MenuItem value={'คืน-ซ่อม'}>{'คืน-ซ่อม'}</MenuItem>
              </Select>
            </FormControl>
          </Box>
        </div>
        <Box className="col-lg-4 col-md-6">
          <Typography className="labelInput">วันคืนวัสดุ</Typography>
          <DatePicker value={returnsDate} onChange={e => setReturnsDate(e)} disabled={id ? true : false} />
        </Box>
      </Box>
      <div class="row">

        <div class="col-lg-4 col-md-6" style={{ marginBottom: '10px' }}>
          <label class="labelInput">จากศูนย์เมล็ดพันธุ์ข้าว</label>
          <Box className={`backgroundField ${branchNoError ? 'error' : ''}`}>
            <FormControl variant="standard" fullWidth disabled={id ? true : false}>
              <Select value={branchNo || ''} onChange={e => {
                setBranchNo(e.target.value)
              }} disableUnderline
                MenuProps={{ PaperProps: { sx: { maxHeight: 400 } } }}
                onBlur={e => {
                  if (!e.target.value) {
                    setBranchNoError(true)
                  } else {
                    setBranchNoError(false)
                  }
                }}
              >
                {branchs?.filter(item => profile?.BranchNo?.BranchNo === '00' ? item : item?.BranchNo === profile?.BranchNo?.BranchNo).map((x) => (
                  <MenuItem value={x?.BranchNo}>{x?.BranchName}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>
          {branchNoError && <span style={{ color: 'red', fontSize: '12px', }}>กรุณาเลือกศูนย์เมล็ดพันธุ์ข้าว</span>}

        </div>
        <div class="col-lg-4 col-md-6" style={{ marginBottom: '10px' }}>
          <label class="labelInput">หน่วยงานที่ส่งคืน</label>
          <Box className={`backgroundField ${departmentNameError ? 'error' : ''}`}>
            <FormControl variant="standard" fullWidth disabled={id ? true : false}>
              <Select value={departmentName || ''} onChange={e => {
                setDepartmentName(e.target.value)
              }} disableUnderline
                MenuProps={{ PaperProps: { sx: { maxHeight: 400 } } }}
                onBlur={e => {
                  if (!e.target.value) {
                    setDepartmentNameError(true)
                  } else {
                    setDepartmentNameError(false)
                  }
                }}
              >
                {departments?.map((x) => (
                  <MenuItem value={x?.DepartmentName}>{x?.DepartmentName}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>
          {departmentNameError && <span style={{ color: 'red', fontSize: '12px', }}>กรุณาเลือกหน่วยงานที่ส่งคืน</span>}

        </div>

      </div>
      <div class="row">
        <div class="col-lg-4 col-md-6" style={{ marginBottom: '10px' }}>
          <label class="labelInput">ไปศูนย์เมล็ดพันธุ์ข้าว</label>
          <Box className={`backgroundField ${toBranchNoError ? 'error' : ''}`}>
            <FormControl variant="standard" fullWidth disabled={id ? true : false}>
              <Select value={toBranchNo || ''} onChange={e => {
                setToBranchNo(e.target.value)
              }} disableUnderline
                MenuProps={{ PaperProps: { sx: { maxHeight: 400 } } }}
                onBlur={e => {
                  if (!e.target.value) {
                    setToBranchNoError(true)
                  } else {
                    setToBranchNoError(false)
                  }
                }}
              >
                {branchs?.map((x) => (
                  <MenuItem value={x?.BranchNo}>{x?.BranchName}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>
          {toBranchNoError && <span style={{ color: 'red', fontSize: '12px', }}>กรุณาเลือกศูนย์เมล็ดพันธุ์ข้าว</span>}

        </div>
        <div class="col-lg-4 col-md-6" style={{ marginBottom: '10px' }}>
          <label class="labelInput">หน่วยงานที่รับคืน</label>
          <Box className={`backgroundField ${toDepartmentNameError ? 'error' : ''}`}>
            <FormControl variant="standard" fullWidth disabled={id ? true : false}>
              <Select value={toDepartmentName || ''} onChange={e => {
                setToDepartmentName(e.target.value)
              }} disableUnderline
                MenuProps={{ PaperProps: { sx: { maxHeight: 400 } } }}
                onBlur={e => {
                  if (!e.target.value) {
                    setToDepartmentNameError(true)
                  } else {
                    setToDepartmentNameError(false)
                  }
                }}
              >
                {departments?.map((x) => (
                  <MenuItem value={x?.DepartmentName}>{x?.DepartmentName}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>
          {toDepartmentNameError && <span style={{ color: 'red', fontSize: '12px', }}>กรุณาเลือกหน่วยงานที่รับคืนบ</span>}

        </div>
      </div>
      {branchNo && departmentName ?
        <>
          <TitlePage title='รายการคืนวัสดุ' action={
            <FontAwesomeIcon icon={faPlusCircle} onClick={addRow} />
          } />
          <div class="addDetail row">
            <div class="col-md-12 table-responsive-sm" style={{ height: 'auto' }}>
              <table class="table table-borderless">
                <thead>
                  <tr>
                    <th class="text-center" >ที่</th>
                    <th class="text-center">เอกสารที่อ้างถึง</th>
                    <th class="text-center" >รายการ</th>
                    <th class="text-center" >ปีงบประมาณ</th>
                    <th class="text-center" >ประเภทเงิน</th>
                    <th class="text-center" >เลขครุภัณฑ์</th>
                    <th class="text-center" >ปริมาณ</th>
                    <th class="text-center" >หน่วย</th>
                    <th class="text-center" >กว้าง (เมตร) </th>
                    <th class="text-center" >ยาว (เมตร)</th>
                    <th class="text-center" >หนา (มิลลิเมตร)</th>
                    <th class="text-center" >ราคา/หน่วย (บาท)</th>
                    <th class="text-center" >สถานะ</th>
                    <th class="text-center" >หมายเหตุ</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody class="">
                  {rows?.map((item, i) => {
                    return (
                      <tr key={i}>
                        <td>{i + 1} .</td>
                        <td>
                          <TextField
                            value={item?.RefNo || ''}
                            onChange={e => {
                              const newItem = rows?.map((v, index) => {
                                v.RefNo = i === index ? e.target.value : v?.RefNo;
                                return v;

                              });
                              setRows([...newItem]);
                            }}
                            sx={{ background: '#fff', width: '100%' }}
                            size='small' variant='outlined'
                            onKeyPress={(event) => {
                              if (!/[0-9]/.test(event.key)) {
                                event.preventDefault();
                              }
                            }} />
                        </td>
                        <td>
                          <Autocomplete
                            size='small'
                            options={materials}
                            getOptionLabel={(option) => option?.ItemName}
                            onBlur={e => {
                              const newItem = rows?.map((v, index) => {
                                v.itemError = index === i ? item.ItemNo ? false : true : v?.itemError;
                                return v;

                              });
                              setRows([...newItem]);
                            }
                            }
                            componentsProps={{
                              paper: {
                                sx: {
                                  width: 500
                                }
                              }
                            }}
                            renderOption={(props, option) => (
                              <Box component="li" {...props} key={option.ItemNo}>
                                {option?.ItemName} {option?.BudgetYear} {option?.BudgetType} {option?.Status} {option?.Size}
                              </Box>
                            )}
                            value={item?.ItemNo}
                            onChange={(event, newValue) => {
                              const newItem = rows?.map((v, index) => {
                                v.ItemNo = index === i ? newValue : v?.ItemNo;
                                v.BudgetYear = index === i ? newValue?.BudgetYear : v?.BudgetYear
                                v.BudgetType = index === i ? newValue?.BudgetType : v?.BudgetType
                                v.Lot = index === i ? newValue?.Lot : v?.Lot
                                v.Balance = index === i ? newValue?.Balance : v?.Balance
                                v.UnitNo = index === i ? newValue?.UnitNo : v?.UnitNo
                                v.Width = index === i ? newValue?.Width / 100 : v?.Width
                                v.Length = index === i ? newValue?.Length / 100 : v?.Length
                                v.Thick = index === i ? newValue?.Thick / 100 : v?.Thick
                                v.CostPrice = index === i ? newValue?.CostPrice : v?.CostPrice
                                v.RequireSize = index === i ? newValue?.CatalogNo?.RequireSize : v?.RequireSize
                                v.Status = index === i ? newValue?.Status : v?.Status
                                v.Qty = index === i ? 0 : v?.Qty
                                return v;

                              });
                              setRows([...newItem]);

                            }}

                            renderInput={(params) => (
                              <Box ref={params.InputProps.ref}>
                                <OutlinedInput error={item?.ItemNo ? false : true} {...params.inputProps} fullWidth size='small' sx={{ padding: '0 !important', background: '#fff' }} />
                              </Box>
                            )}
                          />
                        </td>
                        <td>
                          <FormControl variant="outlined" size='small' fullWidth
                            sx={{ background: '#e9ecef', width: '100%' }}
                          >
                            <Select readOnly value={item?.BudgetYear} onChange={e => {
                              const newItem = rows?.map((v, index) => {
                                v.BudgetYear = i === index ? e.target.value : v?.BudgetYear;
                                return v;

                              });
                              setRows([...newItem]);
                            }} onBlur={e => {
                              const newItem = rows?.map((v, index) => {
                                v.BudgetYearError = index === i ? item.BudgetYear ? false : true : v?.BudgetYearError;
                                return v;

                              });
                              setRows([...newItem]);
                            }} >
                              {budgetYears?.map((z, i) => (
                                <MenuItem key={i} value={z?.BudgetYear}>{z?.BudgetYear}</MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </td>
                        <td>
                          <FormControl variant="outlined" size='small' fullWidth
                            error={item?.BudgetTypeError}
                            sx={{ background: '#e9ecef', width: '100%' }}
                          >
                            <Select readOnly value={item?.BudgetType} onChange={e => {
                              const newItem = rows?.map((v, index) => {
                                v.BudgetType = i === index ? e.target.value : v?.BudgetType;
                                return v;

                              });
                              setRows([...newItem]);
                            }} onBlur={e => {
                              const newItem = rows?.map((v, index) => {
                                v.BudgetTypeError = index === i ? item.BudgetType ? false : true : v?.BudgetTypeError;
                                v.Lot = i === index ? e.target.value === 'เงินทุนหมุนเวียนฯ' ? '' : v?.Lot : v?.Lot

                                return v;

                              });
                              setRows([...newItem]);
                            }} >
                              <MenuItem value='เงินงบประมาณ'>เงินงบประมาณ</MenuItem>
                              <MenuItem value='เงินทุนหมุนเวียนฯ'>เงินทุนหมุนเวียนฯ</MenuItem>
                            </Select>
                          </FormControl>
                        </td>
                        <td>
                          <TextField
                            value={item?.Lot || ''}
                            sx={{ background: '#e9ecef', width: '100%' }}
                            InputProps={{
                              readOnly: true
                            }}
                            onChange={e => {
                              const newItem = rows?.map((v, index) => {
                                v.Lot = i === index ? e.target.value : v?.Lot;
                                return v;

                              });
                              setRows([...newItem]);
                            }}
                            disabled={item?.BudgetType !== 'เงินงบประมาณ'}
                            size='small' variant='outlined'
                            onKeyPress={(event) => {
                              if (!/[0-9]/.test(event.key)) {
                                event.preventDefault();
                              }
                            }} />
                        </td>
                        <td style={{ position: 'relative', display: 'flex' }}>
                          <TextField
                            error={item?.Balance < item?.Qty?.toString().replaceAll(',', '')}
                            value={item?.Qty?.toLocaleString() || ''}
                            sx={{ background: '#fff', width: '100%' }}
                            onChange={e => {
                              const newItem = rows?.map((v, index) => {
                                let newValue = e.target.value.replace(/,/g, "");
                                let abc = newValue.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
                                v.Qty = i === index ? +e.target.value?.toString().replaceAll(',', '') > item?.Balance ? item?.Balance.replace(/\B(?=(\d{3})+(?!\d))/g, ',') : abc : v?.Qty;
                                v.OtyError = i === index ? item?.Balance < e.target.value : v?.OtyError;
                                return v;

                              });
                              setRows([...newItem]);
                            }}
                            size='small' variant='outlined'
                            onKeyPress={(event) => {
                              if (!/[0-9]/.test(event.key)) {
                                event.preventDefault();
                              }
                            }} />
\                          {item?.Balance ? <span style={{ color: 'red', fontSize: '12px', position: 'absolute', bottom: '-7px' }}> {`จำนวน: ${documentType === 'คืน-จ่าย' ? (item?.Balance - +item?.Qty?.toString().replaceAll(',', ''))?.toLocaleString() : item?.Balance?.toLocaleString()}`}</span> : ''}

                        </td>
                        <td>
                          <TextField
                            value={item?.UnitNo?.UnitName || ''}
                            sx={{ background: '#e9ecef', width: '100%' }}
                            InputProps={{
                              readOnly: true
                            }}
                            size='small' variant='outlined'
                            onKeyPress={(event) => {
                              if (!/[0-9]/.test(event.key)) {
                                event.preventDefault();
                              }
                            }} />
                        </td>
                        <td>
                          <TextField
                            value={item?.Width || ''}
                            sx={{ background: '#e9ecef', width: '100%' }}
                            InputProps={{
                              readOnly: true
                            }}
                            type='number'
                            onChange={e => {
                              const newItem = rows?.map((v, index) => {
                                v.Width = i === index ? e.target.value : v?.Width;
                                return v;

                              });
                              setRows([...newItem]);
                            }}
                            size='small' variant='outlined'
                          />
                        </td>
                        <td>
                          <TextField
                            value={item?.Length || ''}
                            sx={{ background: '#e9ecef', width: '100%' }}
                            InputProps={{
                              readOnly: true
                            }}
                            type='number'
                            onChange={e => {
                              const newItem = rows?.map((v, index) => {
                                v.Length = i === index ? e.target.value : v?.Length;
                                return v;

                              });
                              setRows([...newItem]);
                            }}
                            size='small' variant='outlined'
                          />
                        </td>
                        <td>
                          <TextField
                            value={item?.Thick || ''}
                            sx={{ background: '#e9ecef', width: '100%' }}
                            InputProps={{
                              readOnly: true
                            }}
                            type='number'
                            onChange={e => {
                              const newItem = rows?.map((v, index) => {
                                v.Thick = i === index ? e.target.value : v?.Thick;
                                return v;

                              });
                              setRows([...newItem]);
                            }}
                            size='small' variant='outlined'
                          />
                        </td>
                        <td>
                          <TextField
                            value={item?.CostPrice?.toLocaleString()}
                            sx={{ background: '#e9ecef', width: '100%' }}
                            InputProps={{
                              readOnly: true
                            }}                            onChange={e => {
                              const newItem = rows?.map((v, index) => {
                                v.CostPrice = i === index ? e.target.value : v?.CostPrice;
                                return v;

                              });
                              setRows([...newItem]);
                            }}
                            size='small' variant='outlined'
                          />
                        </td>
                        <td>
                          <FormControl variant="outlined" size='small' fullWidth sx={{ background: '#e9ecef', width: '100%' }}
                          >
                            <Select readOnly value={item?.Status} onChange={e => {
                              const newItem = rows?.map((v, index) => {
                                v.Status = i === index ? e.target.value : v?.Status;
                                return v;

                              });
                              setRows([...newItem]);
                            }} >
                              <MenuItem value='พร้อมใช้งาน'>พร้อมใช้งาน</MenuItem>
                              <MenuItem value='ชำรุด-รอซ่อม'>ชำรุด-รอซ่อม</MenuItem>
                              <MenuItem value='ชำรุด-ตัดบัญชี'>ชำรุด-ตัดบัญชี</MenuItem>
                            </Select>
                          </FormControl>
                        </td>
                        <td>
                          <TextField
                            value={item?.Remark || ''}
                            sx={{ background: '#fff', width: '100%' }}
                            onChange={e => {
                              const newItem = rows?.map((v, index) => {
                                v.Remark = i === index ? e.target.value : v?.Remark;
                                return v;

                              });
                              setRows([...newItem]);
                            }}
                            size='small' variant='outlined'
                          />
                        </td>
                        <td>
                          {rows.Length < 2 || i === 0 ? null : <FontAwesomeIcon icon={faMinusCircle} onClick={() => deletehand(i)} />}
                        </td>
                      </tr>
                    )
                  })}
                </tbody>
              </table>
            </div>
          </div>
        </> : null}
      <hr class="chr" />
      <div class="row mt-4">
        <div class="col-12">
          <Button onClick={() => navigate(-1)} variant='outlined'
            startIcon={<FontAwesomeIcon icon={faArrowLeft} />}
            sx={{ width: '130px', fontSize: '14px', marginRight: '10px' }}>กลับ</Button>
          <Button variant='contained' onClick={() => {
            if (!branchNo) {
              setBranchNoError(true)
            }
            if (!toBranchNo) {
              setToBranchNoError(true)
            }
            if (!departmentName) {
              setDepartmentNameError(true)
            }
            if (!toDepartmentName) {
              setToDepartmentNameError(true)
            }
            if (branchNo && toDepartmentName && toBranchNo && departmentName) {
              if (rows.filter(item => !item?.ItemNo).length === 0) {
                if (rows.filter(item => item?.Balance < item?.Qty.toString().replaceAll(',', '')).length === 0) {
                  setOpen(true)
                }
              }
            }

          }} sx={{ width: '130px', fontSize: '14px' }}>บันทึก</Button>

        </div>
      </div>
      <ConfirmDialog open={open} setOpen={setOpen} rows={rows} handleSubmit={handleSubmit} loadingSubmit={loadingSubmit} />
    </Page>
  )
}
